//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import payforList from "../../component/payforList/index";
import goodInfo from "../../component/goodInfo/index";
import httpApi from "../../api/cashier";
import { Toast } from "mint-ui";
import wx from "weixin-js-sdk";
import axios from "axios";
export default {
  name: "cashPage",
  data() {
    return {
      payData: { 1: 1 },
      bannerArr: [
        {
          imgUrl: require("../../assets/img/banner.png"),
          expand: "1"
        },
        {
          imgUrl: require("../../assets/img/banner.png"),
          expand: "2"
        },
        {
          imgUrl: require("../../assets/img/banner.png"),
          expand: "3"
        }
      ],
      goodsDetail: {
        payPric: 0,
        total: 0,
        isIntegral: true,
        Integrals: 0,
        goodsName: "青橄榄网络福利社",
        orderNum: "q12391238723948723810283"
      },
      payforList: [
        {
          id: 1,
          iconImg: require("../../assets/img/pay_wechat@2x.png"),
          tit: "微信支付"
        },
        {
          id: 2,
          iconImg: require("../../assets/img/pay_cmbchina@2x.png"),
          tit: "招商银行"
        },
        {
          id: 3,
          iconImg: require("../../assets/img/pay_icbc@2x.png"),
          tit: "工商银行"
        },
        {
          id: 4,
          iconImg: require("../../assets/img/pay_card@2x.png"),
          tit: "一卡通支付"
        },
        {
          id: 5,
          iconImg: require("../../assets/img/pay_wallet@2x.png"),
          tit: "钱包/账户"
        },
        {
          id: 6,
          iconImg: require("../../assets/img/pay_unionpay@2x.png"),
          tit: "银联支付"
        },
        {
          id: 7,
          iconImg: require("../../assets/img/pay_sign@2x.png"),
          tit: "签单"
        },
        {
          id: 8,
          iconImg: require("../../assets/img/pay_alipay@2x.png"),
          tit: "支付宝支付"
        },
        {
          id: 9,
          iconImg: require("../../assets/img/pay_ccb.png"),
          tit: "龙支付"
        },
        {
          id: 10,
          iconImg: require("../../assets/img/pay_yizhifu.png"),
          tit: "翼支付"
        }
      ],
      listData: [],
      subflag: true,
      iscanReunt: false,
      isloading: true,
      selectPayIdx: "",
      zfbPayfor: "",
      payType: "",
      runDask: "",
      time: 0,
      countDownTime: "",
      btn: {
        color: ""
      }
    };
  },
  components: {
    // New,
    payforList,
    goodInfo
  },
  created() {
    this.reload();
    this.getquery();
    let that = this;
    if (JSON.parse(sessionStorage.getItem("data")).overtime) {
      this.time =
        JSON.parse(sessionStorage.getItem("data")).overtime -
        Date.parse(new Date()) / 1000;
      if (this.time < 0) {
        this.countDownTime = "00:00";
        this.btn.color = "gray";
      }
      setInterval(function() {
        if (that.time >= 0) {
          that.countDown(that.time--);
        } else {
          that.btn.color = "gray";
        }
      }, 1000);
    } else {
      this.countDownTime = "-99";
    }
  },
  mounted() {},
  methods: {
    countDown(time) {
      if (JSON.parse(sessionStorage.getItem("data")).overtime < 3600) {
        let min = parseInt(parseFloat(time) / 60);
        // console.log(min);
        min = min < 10 ? "0" + min : min;
        let second = time - min * 60;
        second = second < 10 ? "0" + second : second;
        this.countDownTime = min + ":" + second;
      } else {
        // console.log(time);
        let hour = parseInt(parseFloat(time) / 60 / 60);
        // console.log(hour);
        hour = hour < 10 ? "0" + hour : hour;
        let min = parseInt(parseFloat(time - hour * 3600) / 60);
        min = min < 10 ? "0" + min : min;
        // console.log(min);
        let second = time - hour * 3600 - min * 60;
        second = second < 10 ? "0" + second : second;
        this.countDownTime = hour + ":" + min + ":" + second;
      }
    },
    getquery() {
      console.log("输出信息:", this.$route.query);
      let query = JSON.parse(sessionStorage.getItem("data"));
      this.goodsDetail.payPric = query.total_amount || "0";
      this.goodsDetail.total = query.total_amount || "0";
      this.goodsDetail.goodsName = query.subject || "";
      this.goodsDetail.orderNum = query.out_trade_no || 0;
      this.goodsDetail.isIntegral = query.discount_amount || 0;

      //   this.goodsDetail.product_id = query.product_id || "";
      for (let key in query) {
        if (query.hasOwnProperty(key)) {
          let ele = query[key] || "";
          this.goodsDetail[key] = ele;
        }
      }
      console.log(this.goodsDetail);
      this.goodsDetail.goodsName = unescape(this.goodsDetail.goodsName);
    },
    reload() {
      let query = JSON.parse(sessionStorage.getItem("data"));
      let config = {
        myapp_id: query.myapp_id || ""
      };
      let _this = this;
      httpApi
        .cashierMsg(config)
        .then(res => {
          if (res.status == 200) {
            let channel = JSON.parse(JSON.stringify(res.data.channel));
            let payforList = _this.payforList;
            let listData = [];
            for (let j = 0; j < channel.length; j++) {
              let ele = channel[j];
              for (let i = 0; i < payforList.length; i++) {
                let ele0 = payforList[i];
                if (ele.code_name == ele0.tit) {
                  ele.iconImg = ele.iconImg || ele0.iconImg;
                }
              }
              ele["id"] = ele.sort;
              listData.push(ele);
            }
            this.listData = listData;
            this.iscanReunt = true;
            this.subflag = true;
          } else {
            Toast({
              message: res.msg || "支付异常，请刷新重试",
              iconClass: "icon icon-fail",
              duration: 2000
            });
            this.iscanReunt = false;
            this.subflag = false;
          }
          this.isloading = false;
          if (!query.id_no) {
            let arr = this.listData;
            arr.some((item, index) => {
              if (item.code_name === "一卡通支付") {
                arr.splice(index, 1);
                return index;
              }
            });
          }
        })
        .catch(err => {
          Toast({
            message: err.msg || "支付异常，请刷新重试",
            iconClass: "icon icon-fail",
            duration: 2000
          });
          this.isloading = false;
          this.iscanReunt = false;
          this.subflag = false;
        });
    },
    handleChange(val) {
      console.log("输出信息:", val);
    },
    openPicker() {
      console.log("输出信息:", this.$refs);
      this.$refs.picker.open();
    },

    payforBack(id) {
      let listData = this.listData;
      for (let i = 0; i < listData.length; i++) {
        let ele = listData[i];
        if (ele.id == id) {
          this.selectPayIdx = i;
        }
      }
    },
    submit() {
      if (this.btn.color == "gray") {
        return;
      }
      let subflag = this.subflag;
      let goodsDetail = this.goodsDetail;
      let _this = this;
      let iscanReunt = this.iscanReunt;
      if (!subflag) {
        if (!iscanReunt) {
          Toast({
            message: "当前订单，无效请重试!",
            iconClass: "icon icon-success",
            duration: 20007
          });
        }
        return false;
      }
      this.isloading = true;
      let listData = this.listData;
      let idx = this.selectPayIdx;
      let payforType = listData[idx].channel_code || "";
      this.payType = payforType;
      let discount_amount = this.goodsDetail.Integrals;
      let trade_type = listData[idx].type;
      let sub_openid = this.goodsDetail.sub_openid;
      this.subflag = false;
      let query = JSON.parse(sessionStorage.getItem("data"));
      query.subject = unescape(query.subject);
      let subData = query;
      subData.trade_type = trade_type;
      subData.payment_type = payforType;
      trade_type.toLocaleLowerCase() == "jsapi"
        ? (subData["sub_openid"] = sub_openid)
        : "";
      if (subData.overtime) {
        subData.overtime = parseInt(subData.overtime);
      }
      httpApi
        .payforType(subData)
        .then(res => {
          if (res.status == 200) {
            //支付宝支付
            if (payforType == "alipay") {
              let div = document.createElement("div"); // 创建div
              div.style.display="none"
              div.innerHTML = res.data.form;
              document.body.appendChild(div);
              document.forms[0].submit();
              return;
            }
            //建行支付
            if (payforType == "ccb") {
              let div = document.createElement("div"); // 创建div
              div.style.display="none"
              div.innerHTML = res.data.form;
              document.body.appendChild(div);
              document.forms[0].submit();
              return;
            }
            let ua = navigator.userAgent.toLowerCase(); //判断浏览器的类型
            //微信支付
            if (payforType == "wechat") {
              //微信客户端里点了微信支付
              if (ua.match(/MicroMessenger/i) == "micromessenger") {
                let config = res.data;
                wx.config({
                  debug: false,
                  appId: config.appid,
                  timestamp: config.time_stamp,
                  nonceStr: config.nonce_str,
                  signature: config.pay_sign,
                  jsApiList: ["chooseWXPay"],
                  success(res) {
                    console.log("config设置成功:", res);
                  },
                  fail(err) {
                    console.log("config设置fail:", err);
                  }
                });
                wx.ready(function() {
                  wx.chooseWXPay({
                    timestamp: config.time_stamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                    nonceStr: config.nonce_str, // 支付签名随机串，不长于 32 位
                    package: `prepay_id=${config.prepay_id}`, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                    signType: config.sign_type, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                    paySign: config.pay_sign, // 支付签名
                    success: function(res) {
                      // 支付成功后的回调函数
                      console.log("支付拉起success:", res);
                      // cb(res);
                      Toast({
                        message: "支付成功",
                        iconClass: "icon icon-success",
                        duration: 2000
                      });
                      setTimeout(function() {
                        location.replace(config.redirect_url);
                      }, 1000);
                    },
                    fail: function(err) {
                      console.log("支付拉起fail:", err);
                      //失败回调函数
                      Toast({
                        message: "支付失败" + err.errMsg,
                        iconClass: "icon icon-success",
                        duration: 2000
                      });
                      setTimeout(function() {
                        location.replace(config.redirect_url);
                      }, 1000);
                      // errorCb(res);
                    }
                  });
                });
              } else {
                //浏览器里点微信支付
                window.location.replace(res.data.form);
              }
            }
            //一卡通支付
            if (payforType == "zycard") {
              Toast({
                message: "支付成功",
                iconClass: "icon icon-success",
                duration: 2000
              });
              setTimeout(function() {
                window.location.href = res.data.redirect_url;
              }, 2000);
            }
            //翼支付
            if (payforType == "bestpay") {
              let payData = res.data;
              let html = `<form style="display:none" id="target" action="https://mapi.bestpay.com.cn/mapi/form/cashier/H5/pay" method="POST"> `;
              for (let i in payData) {
                html += ` <input type="text" name="${i}" value="${payData[i]}" />`;
              }
              html += `<hr /> <input type="submit" value="支付" /></form>`;
              let div = document.createElement("div"); // 创建div
              div.innerHTML = html;
              document.body.appendChild(div);
              document.forms[0].submit();
              return;
            }
          } else {
            Toast({
              message: res.msg,
              iconClass: "icon icon-success",
              duration: 2000
            });
          }
          this.subflag = true;
          _this.isloading = false;
        })
        .catch(err => {
          _this.isloading = false;
          Toast({
            message: err.msg,
            iconClass: "icon icon-success",
            duration: 2000
          });
          this.subflag = true;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/cashPage/index.vue